'use strict';
const _ = require('underscore');

const Preferences = require('./preferences');
const RoomFilters = require('./RoomFilters');

/**
 * Model to represent input parameters for: GET /v2/libraries/{libraryKey}/subjects
 */
class SubjectParameters {

    /**
     * List of valid maturityLevels
     */
    static getValidMaturityLevels() {
        // This feels like it should come from thunder but I dont think they provide it
        return ['generalcontent', 'juvenile', 'youngadult', 'adultonly'];
    }

    static getValidMediaTypes() {
        // 'all' is not technically a legal media type but this model's .serialize knows how to handle it correctly
        return ['all', 'ebook', 'audiobook', 'magazine', 'video'];
    }

    constructor(props) {
        // This is concerning that we treat is as singular when the thunder interface treats it as a collection
        this.mediaType      = 'all';
        this.subject        = [];
        this.maturityLevel  = [];
        this.language       = [];
        this.showOnlyAvailable = false;

        this._safeApply(props);
    }

    _safeApply(props) {
        let parameters = _.pick(props, _.keys(this));

        _.each(parameters, (value, key) => {
            // mediaType is alywas a single value
            if (key === 'mediaType' && value) {
                this.mediaType = value;
            }
            else if (key === 'showOnlyAvailable' && value) {
                this.showOnlyAvailable = true;
            }
            // All other parameters need to be arrays
            else if (value) {
                this[key] = _.isArray(value) ? value.slice() : [value];
            }
        });
    }

    /**
     * Applies user profile AudienceSettings to the current parameter set
     * @param {Preferences} userPreferences
     * @param {RoomFilters} roomFilters
     */
    applyApplicationFilters(userPreferences, currentRoom) {
        // The order of these matter since room settings override any profile level settings
        this._applyProfileSettings(userPreferences);

        if (currentRoom) {
            this._applyRoomFilters(currentRoom.filters);
        }
    }

    /**
     * Applies filter constraints from a room to the current parameters instance
     * @param {RoomFilters} roomFilters
     */
    _applyRoomFilters(roomFilters) {
        if (!roomFilters) { return; }

        var filters = new RoomFilters(roomFilters);

        this.mediaType      = _(filters.mediaType).first() || this.mediaType;
        this.subject        = filters.subjects;
        this.language       = filters.language;

        // LHTNG-1318 Apply room maturity filter when present
        if (!_(filters.maturityLevels).isEmpty()) {
            this.maturityLevel  = filters.maturityLevels;
        }
    }

    /**
     * Applies user profile preferences to the current instance
     * @param {Preferences} userPreferences
     */
    _applyProfileSettings(preferences) {
        var profileMaturityFilters = preferences.getAudienceSettingsArray();

        if (!_(profileMaturityFilters).contains('all')) {
            this.maturityLevel = profileMaturityFilters;
        }
        else {
            this.maturityLevel = [];
        }
    }

    /**
     * Returns a formatted object suitable for passing through QueryString.stringify() for mkaing a Thunder request.
     */
    serialize() {
        let response = _.extend({}, this);

        // Scrub all empty properties from the response object to generate a clean query string (was causing trailing &)
        if (!response.mediaType || response.mediaType === 'all') {
            delete response.mediaType;
        }

        _.isEmpty(response.subject)         && delete response.subject;
        _.isEmpty(response.maturityLevel)   && delete response.maturityLevel;
        _.isEmpty(response.language)        && delete response.language;

        return response;
    }
}

module.exports = SubjectParameters;
